import type { NotificacaoRecipientView, DocumentoAnexo } from '../../types/recipient.types';
import { SendMethod, ClassificacaoItem } from '../../types/common.types';
import { StatusNotificacao } from '../../types/status.types';

const remetentes = [
  {
    nomeFantasia: 'Arbitralis Ltda',
    cnpj: '12.345.678/0001-90',
    email: 'contato@arbitralis.com',
    telefone: '(11) 98765-4321',
    endereco: 'Av. Paulista, 1000',
    cidade: 'São Paulo',
    estado: 'SP',
    cep: '01310-100',
    logotipo: '/Logo.svg',
  },
  {
    nomeFantasia: 'Escritório Silva & Associados',
    cnpj: '23.456.789/0001-01',
    email: 'juridico@silvaassociados.com.br',
    telefone: '(11) 3456-7890',
    endereco: 'Rua Augusta, 500',
    cidade: 'São Paulo',
    estado: 'SP',
    cep: '01305-000',
  },
  {
    nomeFantasia: 'Advocacia Oliveira',
    cnpj: '34.567.890/0001-12',
    email: 'atendimento@advocaciaoliveira.com',
    telefone: '(21) 2345-6789',
    endereco: 'Av. Rio Branco, 200',
    cidade: 'Rio de Janeiro',
    estado: 'RJ',
    cep: '20040-000',
  },
  {
    nomeFantasia: 'Banco Crédito Fácil S.A.',
    cnpj: '45.678.901/0001-23',
    email: 'cobranca@creditofacil.com.br',
    telefone: '(11) 4000-1234',
    endereco: 'Av. Brigadeiro Faria Lima, 3000',
    cidade: 'São Paulo',
    estado: 'SP',
    cep: '01451-000',
  },
];

const assuntos = [
  'Comunicação referente a débito em aberto do contrato nº 456, vencido em 10/12/2025',
  'Notificação de cobrança amigável - Acordo nº 789 não cumprido',
  'Aviso de inadimplência - Parcela vencida há 60 dias',
  'Solicitação de regularização de pendências financeiras',
  'Comunicação de débito referente ao processo nº 1234567-89.2025.8.26.0100',
  'Notificação extrajudicial para quitação de valores em atraso',
  'Aviso de cobrança - Contrato de prestação de serviços',
  'Comunicação de pendência financeira e proposta de acordo',
];

function gerarDocumentos(numeroNotificacao: string): DocumentoAnexo[] {
  return [
    {
      id: `doc-${numeroNotificacao}-1`,
      nome: 'Carta_Notificacao.pdf',
      url: `/documentos/${numeroNotificacao}/carta.pdf`,
      tipo: 'carta',
      tamanho: 245000,
      createdAt: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: `doc-${numeroNotificacao}-2`,
      nome: 'Comprovante_Envio.pdf',
      url: `/documentos/${numeroNotificacao}/comprovante.pdf`,
      tipo: 'comprovante_envio',
      tamanho: 180000,
      createdAt: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: `doc-${numeroNotificacao}-3`,
      nome: 'AR_Assinado.pdf',
      url: `/documentos/${numeroNotificacao}/ar.pdf`,
      tipo: 'ar',
      tamanho: 320000,
      createdAt: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString(),
    },
  ];
}

function gerarCodigoRastreio(): string {
  const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numeros = Math.floor(100000000 + Math.random() * 900000000);
  return `${letras[Math.floor(Math.random() * letras.length)]}${letras[Math.floor(Math.random() * letras.length)]}${numeros}BR`;
}

function gerarCodigoAutenticidade(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const parts = [];
  for (let i = 0; i < 3; i++) {
    let part = '';
    for (let j = 0; j < 4; j++) {
      part += chars[Math.floor(Math.random() * chars.length)];
    }
    parts.push(part);
  }
  return parts.join('-');
}

const now = Date.now();
const diasEmMs = 24 * 60 * 60 * 1000;

export const mockNotificacoesRecebidas: NotificacaoRecipientView[] = [
  {
    id: 'not-001',
    empresaId: 'emp-001',
    escritorioId: 'esc-001',
    loteId: 'lote-001',
    numeroNotificacao: '00123',
    linhaNumero: 1,
    statusGeral: StatusNotificacao.ENTREGUE,
    statusLabel: 'Entregue',
    breveRelato: assuntos[0],
    valor: 5420.0,
    metadata: null,
    classificacao: ClassificacaoItem.VALIDA_CORREIO,
    erros: [],
    partes: [
      {
        id: 'parte-001-req',
        pessoaId: 'pessoa-001',
        tipoParte: 'REQUERIDO',
        partePrincipal: true,
        ordemExibicao: 0,
        pessoa: {
          id: 'pessoa-001',
          nomeCompleto: 'João da Silva',
          cpfCnpj: '12345678900',
          email: 'destinatario@email.com',
          telefone: '11987654321',
        },
        enderecos: [
          {
            id: 'end-001',
            cep: '01234-567',
            logradouro: 'Rua das Flores',
            numero: '123',
            complemento: 'Apto 45',
            bairro: 'Centro',
            cidade: 'São Paulo',
            estado: 'SP',
            principal: true,
          },
        ],
      },
    ],
    dataCriacao: new Date(now - 2 * diasEmMs).toISOString(),
    dataAtualizacao: new Date(now - 2 * diasEmMs).toISOString(),

    remetente: remetentes[0],
    dataRecebimento: new Date(now - 2 * diasEmMs).toISOString(),
    codigoAutenticidade: gerarCodigoAutenticidade(),
    rastreioCorreios: gerarCodigoRastreio(),
    statusEntrega: {
      enviado: new Date(now - 3 * diasEmMs).toISOString(),
      emTransito: new Date(now - 2 * diasEmMs + 5 * 60 * 60 * 1000).toISOString(),
      entregue: new Date(now - 2 * diasEmMs).toISOString(),
    },
    documentosAnexos: gerarDocumentos('00123'),
    metodoEnvio: SendMethod.SEDEX,
    foiLida: false,
    comprovanteEnviado: false,
    negociacaoAberta: false,
  },
  {
    id: 'not-002',
    empresaId: 'emp-001',
    escritorioId: 'esc-001',
    loteId: 'lote-002',
    numeroNotificacao: '00098',
    linhaNumero: 1,
    statusGeral: StatusNotificacao.VISUALIZADA,
    statusLabel: 'Lido',
    breveRelato: assuntos[1],
    valor: 1200.0,
    metadata: null,
    classificacao: ClassificacaoItem.VALIDA_DIGITAL,
    erros: [],
    partes: [
      {
        id: 'parte-002-req',
        pessoaId: 'pessoa-002',
        tipoParte: 'REQUERIDO',
        partePrincipal: true,
        ordemExibicao: 0,
        pessoa: {
          id: 'pessoa-002',
          nomeCompleto: 'João da Silva',
          email: 'joao@email.com',
          telefone: '11987654321',
        },
        enderecos: [],
      },
    ],
    dataCriacao: new Date(now - 10 * diasEmMs).toISOString(),
    dataAtualizacao: new Date(now - 8 * diasEmMs).toISOString(),

    remetente: remetentes[1],
    dataRecebimento: new Date(now - 10 * diasEmMs).toISOString(),
    dataLeitura: new Date(now - 8 * diasEmMs).toISOString(),
    codigoAutenticidade: gerarCodigoAutenticidade(),
    documentosAnexos: gerarDocumentos('00098').slice(0, 2),
    metodoEnvio: SendMethod.DIGITAL,
    foiLida: true,
    comprovanteEnviado: false,
    negociacaoAberta: false,
  },
  {
    id: 'not-003',
    empresaId: 'emp-001',
    escritorioId: 'esc-002',
    loteId: 'lote-003',
    numeroNotificacao: '00245',
    linhaNumero: 1,
    statusGeral: StatusNotificacao.ENTREGUE,
    statusLabel: 'Entregue',
    breveRelato: assuntos[2],
    valor: 8750.5,
    metadata: {
      outcomeHeroTitle: 'Manifestação enviada',
      outcomeHeroSubtitle:
        'Sua manifestação foi enviada com sucesso. Agora a empresa notificante irá analisar as informações.',
      outcomeSummaryLabel: 'Resumo do status',
      outcomeStatusText: 'Aguardando resposta',
      outcomeStatusTooltip:
        'Sua manifestação foi registrada e seguirá para análise. Você será notificado quando houver atualização.',
      outcomeDateLabel: 'Data do envio',
      outcomeReferenceLabel: 'Nº de referência',
      outcomeReferenceValue: `#ARB-${Math.floor(10000 + Math.random() * 90000)}-X`,
    },
    classificacao: ClassificacaoItem.VALIDA_CORREIO,
    erros: [],
    partes: [
      {
        id: 'parte-003-req',
        pessoaId: 'pessoa-003',
        tipoParte: 'REQUERIDO',
        partePrincipal: true,
        ordemExibicao: 0,
        pessoa: {
          id: 'pessoa-003',
          nomeCompleto: 'Maria Santos',
          email: 'contato@email.com',
          telefone: '21987654321',
        },
        enderecos: [
          {
            id: 'end-003',
            cep: '20000-000',
            logradouro: 'Av. Atlântica',
            numero: '500',
            bairro: 'Copacabana',
            cidade: 'Rio de Janeiro',
            estado: 'RJ',
            principal: true,
          },
        ],
      },
    ],
    dataCriacao: new Date(now - 15 * diasEmMs).toISOString(),
    dataAtualizacao: new Date(now - 15 * diasEmMs).toISOString(),

    remetente: remetentes[2],
    dataRecebimento: new Date(now - 15 * diasEmMs).toISOString(),
    dataLeitura: new Date(now - 14 * diasEmMs).toISOString(),
    codigoAutenticidade: gerarCodigoAutenticidade(),
    rastreioCorreios: gerarCodigoRastreio(),
    statusEntrega: {
      enviado: new Date(now - 16 * diasEmMs).toISOString(),
      emTransito: new Date(now - 15 * diasEmMs + 3 * 60 * 60 * 1000).toISOString(),
      entregue: new Date(now - 15 * diasEmMs).toISOString(),
    },
    documentosAnexos: gerarDocumentos('00245'),
    metodoEnvio: SendMethod.DIGITAL_SEDEX,
    foiLida: true,
    comprovanteEnviado: true,
    negociacaoAberta: false,
  },
  {
    id: 'not-006',
    empresaId: 'emp-001',
    escritorioId: 'esc-001',
    loteId: 'lote-006',
    numeroNotificacao: '00992',
    linhaNumero: 1,
    statusGeral: StatusNotificacao.CONCLUIDA,
    statusLabel: 'Concluída',
    breveRelato: assuntos[7],
    valor: 3200.0,
    metadata: {
      outcomeHeroTitle: 'Tudo certo!',
      outcomeHeroSubtitle: 'Sua pendência foi resolvida com sucesso através da nossa plataforma.',
      outcomeSummaryLabel: 'Resumo do acordo',
      outcomeStatusText: 'Concluído',
      outcomeStatusTooltip: 'Processo finalizado. Nenhuma ação adicional é necessária.',
      outcomeDateLabel: 'Data da resolução',
      outcomeReferenceLabel: 'Nº de referência',
      outcomeReferenceValue: `#ARB-${Math.floor(10000 + Math.random() * 90000)}-X`,
    },
    classificacao: ClassificacaoItem.VALIDA_DIGITAL,
    erros: [],
    partes: [
      {
        id: 'parte-006-req',
        pessoaId: 'pessoa-006',
        tipoParte: 'REQUERIDO',
        partePrincipal: true,
        ordemExibicao: 0,
        pessoa: {
          id: 'pessoa-006',
          nomeCompleto: 'Ana Paula Costa',
          email: 'financeiro@email.com',
          telefone: '11911112222',
        },
        enderecos: [],
      },
    ],
    dataCriacao: new Date(now - 30 * diasEmMs).toISOString(),
    dataAtualizacao: new Date(now - 2 * diasEmMs).toISOString(),

    remetente: remetentes[0],
    dataRecebimento: new Date(now - 30 * diasEmMs).toISOString(),
    codigoAutenticidade: gerarCodigoAutenticidade(),
    documentosAnexos: gerarDocumentos('00992'),
    metodoEnvio: SendMethod.DIGITAL,
    foiLida: true,
    comprovanteEnviado: true,
    negociacaoAberta: false,
  },
  {
    id: 'not-007',
    empresaId: 'emp-001',
    escritorioId: 'esc-002',
    loteId: 'lote-007',
    numeroNotificacao: '00993',
    linhaNumero: 1,
    statusGeral: StatusNotificacao.CANCELADA,
    statusLabel: 'Cancelada',
    breveRelato: assuntos[6],
    valor: 0,
    metadata: {
      outcomeHeroTitle: 'Notificação encerrada',
      outcomeHeroSubtitle: 'Esta notificação foi encerrada e não requer mais nenhuma ação sua.',
      outcomeSummaryLabel: 'Resumo do status',
      outcomeStatusText: 'Cancelada',
      outcomeStatusTooltip: 'Este fluxo foi encerrado e não permite novas ações.',
      outcomeDateLabel: 'Data do cancelamento',
      outcomeReferenceLabel: 'Nº de referência',
      outcomeReferenceValue: `#ARB-${Math.floor(10000 + Math.random() * 90000)}-X`,
      outcomeCancelReasonTitle: 'Motivo do cancelamento',
      outcomeCancelReasonText: 'O processo foi encerrado antes da finalização do fluxo.',
    },
    classificacao: ClassificacaoItem.VALIDA_DIGITAL,
    erros: [],
    partes: [
      {
        id: 'parte-007-req',
        pessoaId: 'pessoa-007',
        tipoParte: 'REQUERIDO',
        partePrincipal: true,
        ordemExibicao: 0,
        pessoa: {
          id: 'pessoa-007',
          nomeCompleto: 'Carlos Oliveira',
          email: 'cancelamento@email.com',
          telefone: '21999990000',
        },
        enderecos: [],
      },
    ],
    dataCriacao: new Date(now - 12 * diasEmMs).toISOString(),
    dataAtualizacao: new Date(now - 4 * diasEmMs).toISOString(),

    remetente: remetentes[1],
    dataRecebimento: new Date(now - 12 * diasEmMs).toISOString(),
    codigoAutenticidade: gerarCodigoAutenticidade(),
    documentosAnexos: gerarDocumentos('00993').slice(0, 1),
    metodoEnvio: SendMethod.EMAIL_APENAS,
    foiLida: true,
    comprovanteEnviado: false,
    negociacaoAberta: false,
  },
  {
    id: 'not-004',
    empresaId: 'emp-001',
    escritorioId: 'esc-003',
    loteId: 'lote-004',
    numeroNotificacao: '00312',
    linhaNumero: 1,
    statusGeral: StatusNotificacao.VISUALIZADA,
    statusLabel: 'Lido',
    breveRelato: assuntos[3],
    valor: 3500.0,
    metadata: null,
    classificacao: ClassificacaoItem.VALIDA_DIGITAL,
    erros: [],
    partes: [
      {
        id: 'parte-004-req',
        pessoaId: 'pessoa-004',
        tipoParte: 'REQUERIDO',
        partePrincipal: true,
        ordemExibicao: 0,
        pessoa: {
          id: 'pessoa-004',
          nomeCompleto: 'Carlos Oliveira',
          email: 'carlos@email.com',
          telefone: '11999887766',
        },
        enderecos: [],
      },
    ],
    dataCriacao: new Date(now - 20 * diasEmMs).toISOString(),
    dataAtualizacao: new Date(now - 18 * diasEmMs).toISOString(),

    remetente: remetentes[3],
    dataRecebimento: new Date(now - 20 * diasEmMs).toISOString(),
    dataLeitura: new Date(now - 18 * diasEmMs).toISOString(),
    codigoAutenticidade: gerarCodigoAutenticidade(),
    documentosAnexos: gerarDocumentos('00312').slice(0, 2),
    metodoEnvio: SendMethod.EMAIL_APENAS,
    foiLida: true,
    comprovanteEnviado: false,
    negociacaoAberta: true,
  },
  {
    id: 'not-005',
    empresaId: 'emp-001',
    escritorioId: 'esc-001',
    loteId: 'lote-005',
    numeroNotificacao: '00401',
    linhaNumero: 1,
    statusGeral: StatusNotificacao.ENTREGUE,
    statusLabel: 'Entregue',
    breveRelato: assuntos[4],
    valor: 15200.0,
    metadata: null,
    classificacao: ClassificacaoItem.VALIDA_CORREIO,
    erros: [],
    partes: [
      {
        id: 'parte-005-req',
        pessoaId: 'pessoa-005',
        tipoParte: 'REQUERIDO',
        partePrincipal: true,
        ordemExibicao: 0,
        pessoa: {
          id: 'pessoa-005',
          nomeCompleto: 'Ana Paula Costa',
          email: 'ana@email.com',
          telefone: '11988776655',
        },
        enderecos: [
          {
            id: 'end-005',
            cep: '04567-890',
            logradouro: 'Rua dos Pinheiros',
            numero: '789',
            bairro: 'Pinheiros',
            cidade: 'São Paulo',
            estado: 'SP',
            principal: true,
          },
        ],
      },
    ],
    dataCriacao: new Date(now - 5 * diasEmMs).toISOString(),
    dataAtualizacao: new Date(now - 5 * diasEmMs).toISOString(),

    remetente: remetentes[0],
    dataRecebimento: new Date(now - 5 * diasEmMs).toISOString(),
    codigoAutenticidade: gerarCodigoAutenticidade(),
    rastreioCorreios: gerarCodigoRastreio(),
    statusEntrega: {
      enviado: new Date(now - 6 * diasEmMs).toISOString(),
      emTransito: new Date(now - 5 * diasEmMs + 2 * 60 * 60 * 1000).toISOString(),
      entregue: new Date(now - 5 * diasEmMs).toISOString(),
    },
    documentosAnexos: gerarDocumentos('00401'),
    metodoEnvio: SendMethod.SEDEX,
    foiLida: false,
    comprovanteEnviado: false,
    negociacaoAberta: false,
  },
];

export function getNotificacaoById(id: string): NotificacaoRecipientView | undefined {
  return mockNotificacoesRecebidas.find((n) => n.id === id);
}

export function filtrarNotificacoes(
  notificacoes: NotificacaoRecipientView[],
  filters: {
    status?: 'todas' | 'nao_lidas' | 'lidas' | 'arquivadas';
    ano?: number;
    search?: string;
  },
): NotificacaoRecipientView[] {
  let resultado = [...notificacoes];

  if (filters.status && filters.status !== 'todas') {
    if (filters.status === 'nao_lidas') {
      resultado = resultado.filter((n) => !n.foiLida);
    } else if (filters.status === 'lidas') {
      resultado = resultado.filter((n) => n.foiLida);
    }
  }

  if (filters.ano) {
    resultado = resultado.filter((n) => {
      const ano = new Date(n.dataRecebimento).getFullYear();
      return ano === filters.ano;
    });
  }

  if (filters.search) {
    const searchLower = filters.search.toLowerCase();
    resultado = resultado.filter((n) => {
      return (
        n.numeroNotificacao?.toLowerCase().includes(searchLower) ||
        n.remetente.nomeFantasia.toLowerCase().includes(searchLower) ||
        n.valor.toString().includes(searchLower) ||
        n.breveRelato.toLowerCase().includes(searchLower)
      );
    });
  }

  return resultado;
}
